import { BRAILLE } from '../../../symbols';
import { translate } from '../../../translator';

interface VerifyDrawAnswerResponse {
  symbol: BRAILLE;
  correct: boolean;
}

export const verifyDrawAnswer = (params: {
  correctWord: string;
  drawnSymbols: BRAILLE[];
}): VerifyDrawAnswerResponse[] => {
  const { correctWord, drawnSymbols } = params;

  const correctSymbols = translate(correctWord);

  return correctSymbols.map((symbol, i) => ({
    symbol,
    correct: drawnSymbols[i] === symbol,
  }));
};
